import React, {useEffect, useState} from 'react';
import Badge from 'react-bootstrap/Badge';
import {useIntl} from 'react-intl';

import API from '../../common/utils/API';

export const IN_FLIGHT_POLL_MS = 5000;

/**
 * Contador de compras en curso de la fila `payments`. Consulta al montar y
 * cada 5 s mientras la pantalla esté abierta; el intervalo se limpia al
 * desmontar. Con `payments` apagado y N = 0 no hay compra que un deploy pueda
 * interrumpir, así que se marca como seguro para desplegar (salvo con
 * `showSafeToDeploy={false}`, que usa el modal de confirmación).
 */
function PaymentsInFlight({enabled, showSafeToDeploy = true}) {
    const intl = useIntl();
    const [inFlight, setInFlight] = useState(null);

    useEffect(() => {
        let active = true;

        async function fetchInFlight() {
            try {
                const count = await API.killSwitches.inFlight();
                if (active) setInFlight(count);
            } catch (e) {
                // Si una consulta falla se conserva el último valor conocido;
                // el siguiente ciclo lo vuelve a intentar.
            }
        }

        fetchInFlight();
        const interval = setInterval(fetchInFlight, IN_FLIGHT_POLL_MS);

        return () => {
            active = false;
            clearInterval(interval);
        };
    }, []);

    return (
        <div className='mt-1' data-test='paymentsInFlight'>
            <small data-test='paymentsInFlightCount'>
                {intl.formatMessage(
                    {id: 'KILL_SWITCHES.IN_FLIGHT'},
                    {count: inFlight === null ? '…' : inFlight},
                )}
            </small>
            {showSafeToDeploy && !enabled && inFlight === 0 && (
                <div>
                    <Badge variant='success' data-test='paymentsSafeToDeploy'>
                        {intl.formatMessage({
                            id: 'KILL_SWITCHES.SAFE_TO_DEPLOY',
                        })}
                    </Badge>
                </div>
            )}
        </div>
    );
}

export default PaymentsInFlight;
